/**
 * Filtros de operação do Inbox (HJ-02): mesmas regras e janelas dos totais da tela Hoje (today-v2),
 * para que clicar num número da Hoje abra exatamente essas conversas.
 */
export const AWAITING_WINDOW_HOURS = 72;
export const RISK_SILENT_MIN_DAYS = 4;
export const RISK_SILENT_MAX_DAYS = 30;

export type OperationalFilter = 'ai-attending' | 'awaiting' | 'needs-human' | 'risk-silent';

export interface OperationalContact {
  aiActive?: number | null;
  archived?: boolean;
  lastMessageTime?: string | null;
  lastMessageFromCustomer?: boolean | null;
  unreadCount?: number | null;
}

export function isOperationalFilter(value: string): value is OperationalFilter {
  return value === 'ai-attending' || value === 'awaiting' || value === 'needs-human' || value === 'risk-silent';
}

function hoursSince(iso: string | null | undefined, now: Date): number | null {
  if (!iso) return null;
  const t = new Date(iso).getTime();
  if (!Number.isFinite(t)) return null;
  return (now.getTime() - t) / 3_600_000;
}

/** Cliente falou por último na janela e ninguém respondeu (mensagem nova no polling também conta). */
export function isAwaitingReply(contact: OperationalContact, now: Date, hasNewMessage = false): boolean {
  if (contact.archived) return false;
  if (hasNewMessage) return true;
  const h = hoursSince(contact.lastMessageTime, now);
  if (h == null || h >= AWAITING_WINDOW_HOURS) return false;
  if (contact.lastMessageFromCustomer === true) return true;
  // API antiga sem o campo: "não lida" é a melhor aproximação disponível.
  return contact.lastMessageFromCustomer == null && (contact.unreadCount || 0) > 0;
}

export function matchesOperationalFilter(
  filter: OperationalFilter,
  contact: OperationalContact,
  now: Date,
  hasNewMessage = false,
): boolean {
  if (contact.archived) return false;
  const h = hoursSince(contact.lastMessageTime, now);
  switch (filter) {
    case 'ai-attending':
      return contact.aiActive === 1 && h != null && h < AWAITING_WINDOW_HOURS;
    case 'awaiting':
      return isAwaitingReply(contact, now, hasNewMessage);
    case 'needs-human':
      return contact.aiActive !== 1 && isAwaitingReply(contact, now, hasNewMessage);
    case 'risk-silent':
      return h != null && h >= RISK_SILENT_MIN_DAYS * 24 && h < RISK_SILENT_MAX_DAYS * 24;
    default:
      return false;
  }
}
